import React, { useState } from "react";
import {
  AppBar,
  Avatar,
  Tab,
  Tabs,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, animateScroll } from "react-scroll";
import DrawerComp from "./DrawerComp";
import { onButtonClick } from "./download";

const pages = [
  { name: "Home", link: "/", class: "home" },
  { name: "About", link: "about", class: "about" },
  { name: "Skills", link: "skills", class: "skills" },
  { name: "Projects", link: "projects", class: "projects" },
  { name: "Contact", link: "contact", class: "contact" },
  { name: "Resume", link: "bt", class: "resume" },
];

// export const onButtonClick = () => {
//   saveAs(
//     "https://drive.google.com/u/0/uc?id=1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U&export=download"
//   );
// };
const Navbar = () => {
  const [value, setValue] = useState(0);
  const [head, setHead] = useState(false);
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <AppBar sx={{ backgroundColor: "#063970", color: "white" }} id="nav-menu">
      <Toolbar>
        <a href="/">
          <Avatar src="./logo1.jpg" />
        </a>
        {isMatch ? (
          <>
            <DrawerComp setValue={setValue} />
          </>
        ) : (
          <Tabs
            sx={{ marginLeft: "auto", color: "white" }}
            textColor="inherit"
            value={value}
            indicatorColor="secondary"
          >
            {pages.map((elem, index) =>
              elem.link !== "bt" ? (
                <Link
                  activeClass="active"
                  key={index}
                  to={elem.link}
                  onClick={() => {
                    elem.link === "/"
                      ? animateScroll.scrollToTop()
                      : setHead(true);
                  }}
                  spy={true}
                  smooth={true}
                  className={`nav-link ${elem.class}`}
                >
                  <Tab
                    label={elem.name}
                    sx={{
                      fontSize: "1.2rem",
                      color: "white",
                      fontWeight: "800",
                    }}
                    onClick={() => setValue(index)}
                  />
                </Link>
              ) : (
                <a
                  href="https://drive.google.com/file/d/1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none" }}
                  className={`nav-link ${elem.class}`}
                >
                  <Tab
                    id="resume-button-1"
                    label={elem.name}
                    sx={{
                      fontSize: "1.2rem",
                      color: "white",
                      fontWeight: "800",
                    }}
                    onClick={onButtonClick}
                  />
                </a>
              )
            )}
          </Tabs>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
